module.exports = __webpack_public_path__ + "static/media/compass-background-mobile.fba748fd.svg";